<div class="header mt-3 mb-3 modal-box">
  <div class="d-flex justify-content-end">
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor"
      (click)="closeDialog()"
    />
  </div>

  <div
    class="row d-flex flex-column justify-content-center align-items-center pt-2 mb-2"
  >
    <div class="col-8">
      <h2 class="heading1 m-auto pb-3">{{ 'WEB_VERSION_INFO' | translate }}</h2>
      <div class="row d-flex flex-row pl-3">
        <p class="col-6 detail">{{ 'VERSION' | translate }}</p>
        <p class="col-6 detail">{{ version }}</p>
      </div>
      <div class="row d-flex flex-row pl-3">
        <p class="col-6 detail">{{ 'DATE' | translate }}</p>
        <p class="col-6 detail">{{ date }}</p>
      </div>
    </div>
  </div>

  <div
    class="row d-flex flex-column justify-content-center align-items-center pt-2"
  >
    <div class="col-8">
      <h2 class="heading1 m-auto pb-3">{{ 'API_VERSION_INFO' | translate }}</h2>
      <div class="row d-flex flex-row pl-3">
        <p class="col-6 detail">{{ 'VERSION' | translate }}</p>
        <p class="col-6 detail">{{ version }}</p>
      </div>
      <div class="row d-flex flex-row pl-3">
        <p class="col-6 detail">{{ 'DATE' | translate }}</p>
        <p class="col-6 detail">{{ date }}</p>
      </div>
    </div>
  </div>
</div>
